import { CORE_API_OPERATIONS } from './operations.js';
export { CORE_API_OPERATIONS, } from './operations.js';
export { DEMO_OPERATOR_CONSOLE_SNAPSHOT, DEMO_SUBSCRIBER_APP_SNAPSHOT, DEMO_WORKER_APP_SNAPSHOT, FRONTEND_OPERATION_IDS, createDemoFrontendDataSource, } from './frontend-data.js';
export class CoreApiError extends Error {
    status;
    code;
    traceId;
    payload;
    constructor(message, status, code, traceId, payload) {
        super(message);
        this.status = status;
        this.code = code;
        this.traceId = traceId;
        this.payload = payload;
        this.name = 'CoreApiError';
    }
}
const operationsById = new Map(CORE_API_OPERATIONS.map((operation) => [operation.operationId, operation]));
export function createCoreApiClient(options) {
    const baseUrl = options.baseUrl.replace(/\/+$/u, '');
    const fetchImpl = options.fetch ?? fetch;
    async function request(operationId, requestOptions = {}) {
        const operation = operationsById.get(operationId);
        if (operation === undefined) {
            throw new Error(`Unknown core API operation: ${operationId}`);
        }
        const url = new URL(`${baseUrl}${buildPath(operation.path, requestOptions.pathParams ?? {})}`);
        for (const [key, value] of Object.entries(requestOptions.query ?? {})) {
            if (value !== undefined && value !== null) {
                url.searchParams.set(key, String(value));
            }
        }
        const authToken = requestOptions.authToken ?? (await options.getAccessToken?.());
        const headers = {
            ...(requestOptions.body === undefined ? {} : { 'content-type': 'application/json' }),
            ...(authToken === undefined ? {} : { authorization: `Bearer ${authToken}` }),
            ...(requestOptions.idempotencyKey === undefined
                ? {}
                : { 'idempotency-key': requestOptions.idempotencyKey }),
            ...requestOptions.headers,
        };
        const requestInit = {
            headers,
            method: operation.method,
        };
        if (requestOptions.body !== undefined) {
            requestInit.body = JSON.stringify(requestOptions.body);
        }
        const response = await fetchImpl(url, requestInit);
        const payload = await readPayload(response);
        if (!response.ok) {
            throw toCoreApiError(response, payload);
        }
        return payload;
    }
    async function submitWaitlist(input) {
        return request('submitMarketingWaitlist', { body: input });
    }
    return { request, submitWaitlist };
}
function buildPath(path, pathParams) {
    return path.replace(/\{([^}]+)\}/gu, (_match, key) => {
        const value = pathParams[key];
        if (value === undefined) {
            throw new Error(`Missing path parameter: ${key}`);
        }
        return encodeURIComponent(String(value));
    });
}
async function readPayload(response) {
    if (response.status === 204) {
        return undefined;
    }
    const text = await response.text();
    if (text.length === 0) {
        return undefined;
    }
    try {
        return JSON.parse(text);
    }
    catch {
        return text;
    }
}
function toCoreApiError(response, payload) {
    if (typeof payload !== 'object' || payload === null) {
        return new CoreApiError(response.statusText, response.status, undefined, undefined, payload);
    }
    const record = payload;
    const message = typeof record['message'] === 'string' ? record['message'] : response.statusText;
    const code = typeof record['code'] === 'string' ? record['code'] : undefined;
    const traceId = typeof record['traceId'] === 'string' ? record['traceId'] : undefined;
    return new CoreApiError(message, response.status, code, traceId, payload);
}
//# sourceMappingURL=index.js.map